import { InjectionToken } from '@angular/core';

export const FEATURE_NAME = '@vshosting/libs/stripe-payment';

export const API_URL = new InjectionToken<string>('@vshosting/libs/stripe-payment/API_URL');

export const PROCESSING_REPEAT_LIMIT = 8;
export const WAITING_REPEAT_LIMIT = 8;
export const PAYMENT_RECHECK_INTERVAL_MS = 2000;
export const MAX_WAITING_FOR_CONFIRMATION_MS = 15000;
